import { render, staticRenderFns } from "./moduleManage.vue?vue&type=template&id=a973c31e&scoped=true&"
import script from "./moduleManage.vue?vue&type=script&lang=js&"
export * from "./moduleManage.vue?vue&type=script&lang=js&"
import style0 from "./moduleManage.vue?vue&type=style&index=0&id=a973c31e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a973c31e",
  null
  
)

component.options.__file = "moduleManage.vue"
export default component.exports